module.exports = __webpack_public_path__ + "static/wirth-logo-fd16f2b230f45167e37b05ccdfe1db31.png";